module.exports = __webpack_public_path__ + "info.png?419b74000f0976e7b1fa3f2a02120949";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info.png
// module id = 965
// module chunks = 2